<template>
  <div
    :style="{
      backgroundColor: isDarkTheme ? mainBgColor : '#eeeeee',
      minHeight: '100vh',
      height: 'auto',
      paddingBottom: '10px'
    }"
  >
    <QuizHeader :title="null" />
    <div
      :style="{ background: isDarkTheme ? topBgColor : bgTheme }"
      style="height: 200px; border-bottom-left-radius: 20px; border-bottom-right-radius: 20px;"
    ></div>
    <div
      style="margin-left: 15px;margin-right: 15px; margin-top: -115px; margin-bottom: 10px; border-radius: 15px;"
    >
      <div
        :style="{
          backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
          borderRadius: '15px'
        }"
        style="padding: 70px 20px !important;"
        class="congrats-section common-block con-sub-div"
      >
        <div class="circle-timer-section" style="z-index: 999">
          <div class="timer">
            <!-- Label - only shown when time_left > 0 -->
            <span v-if="time_left > 0" class="text-large">Hrs:Mns:Sec</span>

            <div class="question_timer is-countdown">
              <!-- Timer display - only shown when time_left > 0 -->
              <span class="countdown-row countdown-amount" v-if="time_left > 0">
                {{ "00" }} :
                {{
                  Math.floor(time_left / 60) < 10
                    ? "0" + Math.floor(time_left / 60)
                    : Math.floor(time_left / 60)
                }}
                :
                {{
                  time_left % 60 < 10 ? "0" + (time_left % 60) : time_left % 60
                }}
              </span>

              <!-- Times up icon - only shown when time_left <= 0 -->
              <img
                v-else
                src="@/assets/ic_times_up_flyy.png"
                alt="sand icon"
                class="img-fluid"
                style="width: 40px; height: 40px; margin-top: 60px"
              />
            </div>
          </div>
        </div>
        <div style="height: 20px;" v-if="time_left === 0">
          <p></p>
        </div>
        <div v-if="time_left > 0">
          <img
            :src="data_to_show.image_url"
            style="margin-top: 25px;margin-bottom: 20px !important;"
            alt="congrats"
            class="img-fluid w30"
            v-if="data_to_show && data_to_show.image_url"
          />
          <img
            style="margin-top: 25px;margin-bottom: 20px !important;"
            src="@/assets/congrats.svg"
            alt="congrats"
            class="img-fluid"
            v-else
          />
        </div>

        <div
          class="no-margin-html"
          v-if="data_to_show && data_to_show.message"
          v-html="data_to_show.message"
        ></div>

        <span
          style="font-size: 20px !important; margin-bottom: 20px !important; color: #454545; font-weight: 700;"
          v-else
          >Congrats on completing the Quiz!</span
        >

        <!-- <p style="color: #000000;">
          Quiz Score {{ answers_score }}
          <span>Time Bonus {{ time_score }}</span>
        </p> -->
        <p
          style=" font-size: 20px; margin: 30px 0px 10px 0px !important; font-weight: 700; color: #585957;"
        >
          Quiz Score {{ answers_score }}
        </p>
        <p
          style="color: #585957; font-size: 16px; margin: 0px !important; margin-top: 8px; font-weight: 700;"
        >
          Time Bonus {{ time_score }}
        </p>

        <span
          style="color: #323232; margin-top: 35px !important; margin-bottom: 40px !important; font-weight: 800;"
          >Your Score is {{ total_score }}</span
        >

        <div style="width: 100%;">
          <div
            :style="{
              backgroundColor: isDarkTheme ? buttonBGColor : bgTheme,
              color: isDarkTheme ? headingTextColor : '#ffffff'
            }"
            class="btn  see-leadboard"
            role="button"
            v-on:click="handleButtonClick()"
            style="width: 90% !important; font-size: 14px !important; font-weight: 700;"
          >
            {{
              data_to_show && data_to_show.button_text
                ? data_to_show.button_text
                : "SEE LEADERBOARD"
            }}
          </div>
        </div>
        <div style="width: 100%;">
          <div
            v-if="data_to_show && data_to_show.enable_share_link"
            :style="{
              backgroundColor: isDarkTheme ? buttonBGColor : bgTheme,
              color: isDarkTheme ? headingTextColor : '#ffffff',
              marginTop: '10px'
            }"
            class="btn  see-leadboard"
            role="button"
            v-on:click="handleShareClick()"
            style="width: 90% !important; font-size: 14px !important; font-weight: 700;"
          >
            {{ data_to_show.share_button_text || "SHARE YOUR SCORE" }}
          </div>
        </div>
      </div>
    </div>
    <!-- Share Popup -->
    <div
      v-if="showSharePopup"
      style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 1000; display: flex; justify-content: center; align-items: flex-end;"
    >
      <div
        style="position: relative; width: 100%; max-width: 400px; background: white; border-top-left-radius: 20px; border-top-right-radius: 20px; box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2); text-align: center; padding: 20px 0px;"
      >
        <button
          @click="showSharePopup = false"
          :style="{
            position: 'absolute',
            top: '-55px',
            left: '50%',
            transform: 'translateX(-50%)',
            background: 'white',
            color: bgTheme,
            border: 'none',
            borderRadius: '50px',
            padding: '11px 16px',
            fontSize: '14px',
            boxShadow: '0px 2px 6px rgba(0,0,0,0.2)',
            cursor: 'pointer',
            fontWeight: '700',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '5px'
          }"
        >
          <div
            :style="{
              width: '16px',
              height: '16px',
              backgroundColor: bgTheme,
              WebkitMaskImage:
                'url(' + asset('chevron-left-red.png') + ')',
              WebkitMaskRepeat: 'no-repeat',
              WebkitMaskPosition: 'center',
              WebkitMaskSize: 'contain',
              maskImage:
                'url(' + asset('chevron-left-red.png') + ')',
              maskRepeat: 'no-repeat',
              maskPosition: 'center',
              maskSize: 'contain'
            }"
          ></div>
          Go back
        </button>

        <p style="font-weight: bold; margin: 10px 0;">Share via</p>

        <div
          style="display: flex; justify-content: space-evenly; margin-top: 15px;"
        >
          <div
            @click="shareContent('whatsapp', data_to_show.share_text)"
            style="cursor: pointer;"
          >
            <img
              style="cursor: pointer; width: 35px; height: 35px; margin-bottom: 5px;"
              src="@/assets/whatsapp.png"
              alt="whatsapp"
              class="logo-image"
            />
            <p style="margin: 5px 0; font-size: 12px;">WhatsApp</p>
          </div>

          <div
            @click="shareContent('facebook', item.share_text)"
            style="cursor: pointer;"
          >
            <img
              style="cursor: pointer; width: 35px; height: 35px; margin-bottom: 5px;"
              src="@/assets/facebook.png"
              alt="facebook"
              class="logo-image"
            />
            <p style="margin: 5px 0; font-size: 12px;">Facebook</p>
          </div>

          <div
            @click="shareContent('instagram', item.share_text)"
            style="cursor: pointer;"
          >
            <img
              style="cursor: pointer; width: 35px; height: 35px; margin-bottom: 5px;"
              src="@/assets/instagram.png"
              alt="instagram"
              class="logo-image"
            />
            <p style="margin: 5px 0; font-size: 12px;">Instagram</p>
          </div>

          <div @click="copyShareLink" style="text-align: center;">
            <div
              :style="{
                width: '40px',
                height: '40px',
                margin: 'auto',
                backgroundColor: bgTheme,
                borderRadius: '50%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                marginBottom: '5px'
              }"
            >
              <div
                :style="{
                  width: '20px',
                  height: '20px',
                  backgroundColor: 'white',
                  WebkitMaskImage:
                    'url(' + asset('copy-img1.png') + ')',
                  WebkitMaskRepeat: 'no-repeat',
                  WebkitMaskPosition: 'center',
                  WebkitMaskSize: 'contain',
                  maskImage: 'url(' + asset('copy-img1.png') + ')',
                  maskRepeat: 'no-repeat',
                  maskPosition: 'center',
                  maskSize: 'contain'
                }"
              ></div>
            </div>
            <p style="margin: 0px; font-size: 12px; font-weight: bold;">
              Copy link
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Toast Notification -->
    <div
      id="copied-toast"
      class="font-bold pos-fixed pos-center-hor pull-down"
      style="width: 100px; padding: 5px; border-radius: 10px; background: rgba(0, 0, 0, 0.3); margin-bottom: 70px; color: white; display: none; bottom: 10%;"
    >
      Link Copied
    </div>
  </div>
</template>

<script>
import { asset } from "@/utils/asset";
// import Tasks from '../components/Tasks'
import { navigateDeeplink } from "@/utils/deeplink";
import { globals } from "@/mixins/globals";
import QuizHeader from "@/components/quiz-header";
export default {
  mixins: [globals],
  name: "congrats",
  components: {
    QuizHeader
  },
  data: () => ({
    total_score: 0,
    total_questions: 0,
    correct_answers: 0,
    answers_score: 0,
    time_score: 0,
    final_screen_data: [],
    data_to_show: "",
    displayDays: 0,
    displayHours: 0,
    displayMinutes: 0,
    displaySeconds: 0,
    distance: 3600000,
    time_left: 0,
    showSharePopup: false
  }),
  computed: {
    topBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.topBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.topBgColor;
      }
      return null; // fallback
    },
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    buttonBGColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.buttonBGColor
      ) {
        return this.$store.state.sdkEvent.themeColors.buttonBGColor;
      }
      return null; // fallback
    },
    headingTextColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null; // fallback
    },
    offersCardBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null; // fallback
    },
    mainBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.mainBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.mainBgColor;
      }
      return null; // fallback
    },
    _seconds: () => 1000,
    _minutes() {
      return this._seconds * 60;
    },
    _hours() {
      return this._minutes * 60;
    },
    _days() {
      return this._hours * 24;
    }
  },
  methods: {
    shareContent(platform, shareText) {
      const encodedText = encodeURIComponent(shareText);

      switch (platform) {
        case "whatsapp":
          window.open(`https://wa.me/?text=${encodedText}`, "_blank");
          break;

        case "facebook":
          window.open(
            `https://www.facebook.com/sharer/sharer.php?u=${encodedText}`,
            "_blank"
          );
          break;

        case "instagram":
          // Instagram does not support direct text-sharing in browser
          // So we copy text + open Instagram
          navigator.clipboard.writeText(shareText);
          alert("Text copied! Paste it in Instagram.");
          window.open("https://instagram.com/", "_blank");
          break;

        case "twitter":
          window.open(
            `https://twitter.com/intent/tweet?text=${encodedText}`,
            "_blank"
          );
          break;

        default:
          console.warn("Unknown platform");
      }
    },
    copyShareLink() {
      console.log("copy fn...", this.data_to_show.share_text);
      const fullText = this.data_to_show.share_text;

      if (fullText) {
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard
            .writeText(fullText)
            .then(() => {
              this.showCopiedToast();
              this.showSharePopup = false;
            })
            .catch(err => {
              console.warn("Clipboard API failed:", err);
              this.fallbackCopyText(fullText);
            });
        } else {
          this.fallbackCopyText(fullText);
        }
      } else {
        console.warn("No share text found to copy.");
      }
    },

    fallbackCopyText(text) {
      console.log("copy fn - 1...");
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
        const successful = document.execCommand("copy");
        if (successful) {
          this.showCopiedToast();
          this.showSharePopup = false;
        }
      } catch (err) {
        console.error("Fallback copy failed", err);
      }
      document.body.removeChild(textarea);
    },

    showCopiedToast() {
      const toast = document.getElementById("copied-toast");
      if (toast) {
        toast.style.display = "block";
        setTimeout(() => {
          toast.style.display = "none";
        }, 2000); // Hide after 2 seconds
      }
    },
    handleShareClick() {
      console.log("Clicked Share....", this.data_to_show.share_text);
      const text = this.data_to_show.share_text;
      const urlMatch = text.match(/https?:\/\/[^\s]+/);
      if (urlMatch) {
        // window.open(urlMatch[0], '_blank');
        this.showSharePopup = !this.showSharePopup;
      } else {
        console.warn("No valid share URL found in share_link_text");
      }
    },
    handleButtonClick() {
      if (this.data_to_show.button_text) {
        if (this.data_to_show.deeplink) {
          navigateDeeplink(this.$router, this.data_to_show.deeplink);
        } else {
          return;
        }
      } else {
        this.$router.replace("/quiz-history");
      }
    },
    showRemaining() {
      const timer = setInterval(() => {
        if (this.distance < 0) {
          if (this.quizNo == this.quizData.length - 1) {
            clearInterval(timer);
          }
          // this.submitAnswers();
          this.handleNextQuestion();
          return;
        }
        const seconds = parseInt(
          Math.floor(this.distance % this._minutes) / this._seconds
        );
        const minutes = parseInt(
          Math.floor(this.distance % this._hours) / this._minutes
        );
        const days = parseInt(Math.floor(this.distance / this._days));
        const hours = parseInt(
          Math.floor(this.distance % this._days) / this._hours
        );

        this.displayMinutes = minutes < 10 ? "0" + minutes : minutes + "m";
        this.displaySeconds = seconds < 10 ? "0" + seconds : seconds + "s";
        this.displayHours = hours < 10 ? "0" + hours : hours + "h";
        this.displayDays = days < 10 ? "0" + days : days;
        this.distance = this.distance - 1000;
      }, 1000);
    }
  },
  created() {
    // this.$emit('handleHideFooter');
    var self = this;
    this.showRemaining();
    this.total_score = this.$route.params.total_score;
    this.total_questions = this.$route.params.total_questions;
    this.correct_answers = this.$route.params.correct_answers;
    this.answers_score = this.$route.params.answers_score;
    this.time_score = this.$route.params.time_score;
    this.final_screen_data = this.$route.params.final_screen_data;
    this.time_left = this.$store.state.quiz_time_bonus;
    this.$store.state.quizDetailsTitle = "Congrats";
    this.data_to_show = this.$store.state.final_screen_data;
    this.final_screen_data.forEach(function(data) {
      if (self.correct_answers == 0) {
        if (data.configuration_type == "zero") {
          self.data_to_show = data;
          return;
        }
      } else if (self.correct_answers < self.total_questions) {
        if (data.configuration_type == "less_than") {
          self.data_to_show = data;
          return;
        }
      } else {
        if (data.configuration_type == "greater_than") {
          self.data_to_show = data;
          return;
        }
      }
    });
    // if (self.data_to_show) {
    //   self.data_to_show.button_text = null;
    // }
  },
  mounted() {
    this.$store.state.showQuizHistoryMenu = false;
  }
};
</script>

<style scoped>
@import "../assets/quiz-styles/quiz-styles.css";
@import "../assets/quiz-styles/bootstrap.css";
@import "../assets/fonts/quiz-fonts/fonts.css";

@media (max-width: 360px) {
  .custom-height {
    height: 75vh;
  }

  .con-sub-div {
    margin-top: -15px !important;
    height: 82vh;
  }
}

@media (min-width: 361px) and (max-width: 480px) {
  .con-sub-div {
    margin-top: -15px !important;
    height: 72vh;
  }
  /* .custom-height {
    height: 75vh;
  } */
}
</style>
